import { UserTablePage } from "~/domain/common";

export function DsmUserTablePage() {
  return <UserTablePage />;
}
